const isFlagEnabled = (value?: string) => value?.trim().toLowerCase() !== 'false'

export const isDynamicReportsEnabled = isFlagEnabled(process.env.REACT_APP_ENABLE_DYNAMIC_REPORTS)
